// 灵犀登录模块url配置
const apiUrl = {
    /*1.2发送验证码 POST
    {
      "mobile": "U2FsdGVkX182gNXrcYo3WX+siRVV3p44Vc/ExwdoCV0=",
        "scene": 1
    }
   */
    sendCode: "/app-api/member/auth/send-sms-code",
    /*1.3使用手机+密码注册账号 POST
      {
      "mobile": "U2FsdGVkX182gNXrcYo3WX+siRVV3p44Vc/ExwdoCV0=",
      "password": "U2FsdGVkX1+HyegME/9OuHXUX9p3tQlmpUmgsqFXeU4=",
      "code": "123456"
    }
    */
    register: "/app-api/member/auth/register",
    /*1.4使用手机号+密码登录 POST
    {
      "mobile": "U2FsdGVkX182gNXrcYo3WX+siRVV3p44Vc/ExwdoCV0=",
      "password": "U2FsdGVkX1+HyegME/9OuHXUX9p3tQlmpUmgsqFXeU4=",
    }
    */
    authLogin: "/app-api/member/auth/login",
    /*1.5使用一键登录 POST
    {
      "mobile": "U2FsdGVkX182gNXrcYo3WX+siRVV3p44Vc/ExwdoCV0=",
      "password": "U2FsdGVkX1+HyegME/9OuHXUX9p3tQlmpUmgsqFXeU4=",
      "code": "123456"
    }
    */
    loginByCmi: "/app-api/member/auth/login-by-cmi",
    /*1.6使用手机号+验证码登录 POST
    {
      "mobile": "U2FsdGVkX182gNXrcYo3WX+siRVV3p44Vc/ExwdoCV0=",
      "code": "123456"
    }
    */
    smsLogin: "/app-api/member/auth/sms-login",
    /* 1.7重置密码 POST
    {
      "mobile": "U2FsdGVkX182gNXrcYo3WX+siRVV3p44Vc/ExwdoCV0=",
      "password": "U2FsdGVkX1+HyegME/9OuHXUX9p3tQlmpUmgsqFXeU4=",
      "code": "123456"
    }
    */
    resetPassword: "/app-api/member/auth/reset-password",
    /*1.8修改用户密码 POST
    {
      "oldPassword": "U2FsdGVkX182gNXrcYo3WX+siRVV3p44Vc/ExwdoCV0=",
      "password": "U2FsdGVkX1+HyegME/9OuHXUX9p3tQlmpUmgsqFXeU4="
    }
    */
    updatePassword: "/app-api/member/auth/update-password",
    /*1.9刷新用户令牌 POST
    {
      "mobile": "U2FsdGVkX182gNXrcYo3WX+siRVV3p44Vc/ExwdoCV0=",
      "password": "U2FsdGVkX1+HyegME/9OuHXUX9p3tQlmpUmgsqFXeU4=",
      "code": "123456"
    }
    */
    refreshToken: "/app-api/member/auth/refresh-token",
    /*1.10登出账号 POST
     */
    authLogout: "/app-api/member/auth/logout",
    /*1.11获取用户的基本信息 GET
     */
    userGet: "/app-api/member/user/get",
    /*1.12修改用户基本信息 POST
    {
      "nickName": "xxx",
      "sex": 1
    }
    */
    updateBaseInfo: "/app-api/member/user/update-base-info",
    /*1.13.	修改用户头像 PUT
    PUT /app-api/member/user/update-avatar
    Content-Type: multipart/form-data
    Authorization: Bearer your_token_here
  
    --boundary
    Content-Disposition: form-data; name="avatarFile"; filename="avatar.jpg"
    Content-Type: image/jpeg
  
    [二进制文件数据]
    */
    updateAvatar: "/app-api/member/user/update-avatar",
    /*1.14用户上传文件 PUT
    PUT /app-api/member/user/update-avatar
    Content-Type: multipart/form-data
    Authorization: Bearer your_token_here
  
    --boundary
    Content-Disposition: form-data; name="avatarFile"; filename="avatar.jpg"
    Content-Type: image/jpeg
    */
    fileUpload: "/app-api/member/user/file/upload",
    /*1.15用户问题反馈接口 POST
    {
    "type": 0,
    "logUrl":"https: //xxxxxxxxx.com/xxxx",
    "images":"xxx.url",
    "content":"不好用",
    "title":"用户反馈",
    "appVersion":"1.0.0",
    "os":"android",
    "osVersion":"xxxxx",
    "brand":"xiaomi",
    "contact":"183333917@163.com"
    }
    */
    aiFeedback: "/app-api/ai/feedback",
    /*1.16.用户注销账号接口 POST
    {
        "code":  "123456 "
    }
    */
    cleanUp: "/app-api/user/clean-up",
    /*1.17用户更新手机号接口 POST
    {
        "code": "123456 ",
        "mobile":"SEWDSDFSDsddfsdf=",
        "oldMobile":"asdfsdfsdXAFS="
    }
    */
    updateMobile: "/app-api/member/user/update-mobile",
};
export default apiUrl;
